import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import React from 'react';
import i18n from 'i18n-js';
import moment from 'moment';

import { scale } from '@components/frame';
import { convertTimeLetter, isAndroid, localTime, isPhone, isWeb } from '@helpers';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { useRoute } from '@react-navigation/native';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({ C, selectedItem, data: { dataBar = [] }, selectedIndex, toGo, isDay, id, fullWidth, isActive }) => {
  const route = useRoute();
  const loaded = dataBar?.length;

  const chartWidth = isPhone ? fullWidth - scale(60, false) : scale(384, false);
  const chartHeight = scale(119, false);
  const barBlockWidth = chartWidth / (dataBar.length || 1);

  const popupWidth = scale(isDay ? 170 : 148);
  const lineLeft = selectedIndex * barBlockWidth + barBlockWidth / 2;

  const maxPopupLeft = chartWidth - popupWidth;
  const minPopupLeft = 0;

  let popupLeft = lineLeft - popupWidth / 2;

  if (popupLeft > maxPopupLeft) {
    popupLeft = maxPopupLeft;
  }

  if (popupLeft < minPopupLeft) {
    popupLeft = minPopupLeft;
  }

  const time = convertTimeLetter(isActive ? selectedItem.active : selectedItem.productive);

  if (isDay) {
    time.m = Number(time.m) + Number(time.h) * 60;
  }

  const linkConfig = toGo(selectedItem, true);

  const color = {
    [MachinesScreen.ACTIVE]: C('Status/Light/Active'),
    [MachinesScreen.PRODUCTIVE]: C('Status/Light/Productive'),
  };

  return (
    <View style={{ height: scale(81) }}>
      <View
        style={{
          width: popupWidth,
          height: scale(71),
          backgroundColor: C('Fill/Light/Quaternary'),
          borderColor: C('Fill/Light/Quaternary'),
          borderWidth: StyleSheet.hairlineWidth,
          borderRadius: scale(4),
          paddingLeft: scale(8),
          left: popupLeft,
          marginTop: scale(9),
        }}
      >
        {id && !isDay && (
          <TouchableOpacity
            activeOpacity={1}
            onPress={(e) => {
              e.preventDefault();
              toGo(selectedItem);
            }}
            style={{ position: 'absolute', zIndex: 10000, top: scale(3), right: scale(4), borderRadius: scale(SCREEN_BORDER_RADIUS), backgroundColor: C('Fill/Light/Tertiary') }}
            href={
              isDay || !isWeb
                ? ''
                : `${window.location.pathname}?date=${moment(linkConfig?.date).format('YYYY-MM-DD HH:mm')}&ncFileId=${linkConfig?.ncFileId}&status=${
                    linkConfig?.status
                  }&chart=${linkConfig?.chart}&level=${linkConfig?.level}&section=${linkConfig?.section}&period=${linkConfig?.period}&ncFile=${
                    linkConfig?.ncFile
                  }&manufacture=${linkConfig?.manufacture}&noMachine=true`
            }
          >
            <View>
              <Svg icon="togo" width={scale(20)} height={scale(20)} color="Label/Light/Tertiary" />
            </View>
          </TouchableOpacity>
        )}

        <Text
          style={[
            {
              color: color[route.name],
              marginTop: scale(2),
            },
            font['Button 2'],
          ]}
        >
          {i18n.t(route.name)}
        </Text>
        <View style={{ flexDirection: 'row', marginTop: scale(-2), opacity: loaded ? 1 : 0 }}>
          <Text
            style={[
              {
                color: color[route.name],
              },
              font['Large Title'],
            ]}
          >
            {Number(isDay ? time.m : time.h)}
            <Text
              style={[
                font['Button 1'],
                {
                  color: color[route.name],
                },
                isAndroid && { lineHeight: scale(36) },
              ]}
            >
              {i18n.t(isDay ? 'm' : 'h')}{' '}
            </Text>
          </Text>
          <Text
            style={[
              {
                color: color[route.name],
              },
              font['Large Title'],
            ]}
          >
            {Number(isDay ? time.s : time.m)}
            <Text
              style={[
                {
                  color: color[route.name],
                },
                font['Button 1'],
                isAndroid && { lineHeight: scale(36) },
              ]}
            >
              {i18n.t(isDay ? 's' : 'm')}
            </Text>
          </Text>
        </View>
        <Text
          style={[
            {
              color: C('Label/Light/Tertiary'),
              marginTop: scale(-1),
            },
            font['Button 1'],
          ]}
          numberOfLines={1}
          ellipsizeMode={'middle'}
        >
          {selectedItem.date}
        </Text>
      </View>
      <View
        style={{
          position: 'absolute',
          width: 1,
          backgroundColor: C('Label/Light/Tertiary'),
          height: chartHeight - (selectedItem.height / 100) * chartHeight + scale(4),
          top: scale(80),
          left: lineLeft,
          zIndex: 1000,
        }}
      />
    </View>
  );
};
